<template>
  <div>
    <div class="header">
      <h1 class="page-title">申请售后</h1>
    </div>
    <el-card class="box-card">
      <div class="block">
        <div class="header"></div>
        <div class="sy-tit">
          <p>提示</p>
          <span>发起售后时，全部选择售后，待客服审核完成后，届时订单实付款金额会退回到您的云闪印账户，请注意查收。( 如果售后订单没有全部选择售后，将不退运费！ )</span>
        </div>
      </div>

      <div class="main">
        <div class="sy-tit">退货商品</div>

        <el-table
          :data="tableData.data"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          ref="multipleTable"
          :span-method="objectSpanMethod"
        >
          <el-table-column type="selection" width="55" checked></el-table-column>
          <el-table-column label="订单编号">
            <template slot-scope="scope">{{scope.row.order_no + scope.row.pack}}</template>
          </el-table-column>
          <el-table-column prop="product_name" label="产品名称"></el-table-column>
          <el-table-column prop="title" width="350" label="规格"></el-table-column>
          <el-table-column prop="goods_price" label="产品金额"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <el-table-column prop="discount_fee" label="优惠金额">
            <template slot-scope="scope">{{!scope.row.discount_fee ? '0' : scope.row.discount_fee}}</template>
          </el-table-column>
          <el-table-column prop="total_weight" label="总重量（kg）"></el-table-column>
          <el-table-column prop="total_shipping_fee" label="总运费（元）"></el-table-column>
          <el-table-column prop="total_price" label="实付金额"></el-table-column>
        </el-table>

        <div class="productInfo">
          <div class="sy-tit">填写退货信息</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="申请类型" prop="leixing">
              <el-select v-model="ruleForm.leixing" placeholder="请选择退款类型" @change="change">
                <el-option label="仅退全款" value="backmoney"></el-option>
                <el-option label="退货退款" value="backorder"></el-option>
                <el-option label="折让退款" value="zhermoney"></el-option>
                <el-option label="订单补印" value="reorder"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退款理由" prop="liyou">
              <el-select v-model="ruleForm.liyou" placeholder="请选择申请退款理由">
                <el-option
                  v-for="item in liyouList"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退款金额">
              <el-input :disabled="d" v-model="ruleForm.jine" @blur="verifynum($event)"></el-input>
              <template v-if="!d">
                <span class="sy-msg">最大金额为 {{total_price+'元'}} ,最小不能少于0元</span>
                <span class="success_msg" v-if="fflag">&#10004;ok</span>
                <span class="error_msg" v-else>&#10006;请填写正确的金额</span>
              </template>
            </el-form-item>
            <el-form-item label="申请说明" prop="shuoming">
              <el-input type="textarea" v-model="ruleForm.shuoming"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone" v-if="!disabled">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="快递单号" prop="expressno" v-if="!disabled">
              <el-input v-model="ruleForm.expressno"></el-input>
            </el-form-item>

            <el-form-item label="上传图片" class="upload-item">
              <span class="xing">*</span>
              <div class="f">
                <form name="theform">
                  <input
                    style="display:none"
                    type="radio"
                    name="myradio"
                    checked="true"
                    value="local_name"
                  />
                  <input style="display:none" type="radio" name="myradio" value="random_name" />
                  <input style="display:none" type="text" id="dirname" :value="filePath" size="50" />
                </form>
                <div class="contaniner">
                  <a id="selectfiles" href="javascript:void(0);" class="btn">上传图片</a>
                  <span class="uploadmsg">(只能上传JPG、PNG、GIF格式，最大2m)</span>
                </div>
                <div id="ossfile"></div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import '../../../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../../../public/PLupload/lib/base64.js'
import plupload from 'plupload'

let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''

const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr + '/api/car/editcar'
  : 'https://www.yunshanyin.nett' + '/api/car/editcar'

var policyText = {
  expiration: '2030-05-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}

function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  let pwd = filename
  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }

  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', // 让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}
let f = false
let imgSrc = ''
export default {
  data() {
    return {
      fflag: 'true',
      // 订单id
      id: '',
      order_no: '',
      tableData: { data: [] },
      // 退款金额
      total_price: '',
      ruleForm: {
        leixing: 'backmoney',
        liyou: '',
        jine: '',
        shuoming: '',
        phone: '',
        expressno: ''
      },
      rules: {
        leixing: [
          { required: true, message: '请选择退款类型', trigger: 'change' }
        ],
        liyou: [
          { required: true, message: '请选择申请退款理由', trigger: 'change' }
        ],
        shuoming: [
          { required: true, message: '请输入申请说明', trigger: 'blur' },
          {
            min: 4,
            max: 200,
            message: '申请原因长度在 4 到 200 个字符',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        expressno: [
          { required: true, message: '请输入您寄件的快递单号', trigger: 'blur' }
        ]
      },
      filePath: '',
      liyouList: [],
      // 选中的列表项
      Data: []
    }
  },
  computed: {
    disabled() {
      if (this.ruleForm.leixing == 'backorder') {
        this.ruleForm.jine = this.total_price
        return false
      }
      return true
    },
    d() {
      if (this.ruleForm.leixing == 'zhermoney') {
        return false
      }
      return true
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.order_no = this.$route.params.id
      this.queryOrderDeatil()
      let u = JSON.parse(window.localStorage.getItem('u'))
      this.filePath =
        'uploads/' +
        u.mobile +
        '/' +
        new Date().toLocaleDateString().replace(/\//g, '-')
    }
    this.queryBackLiyou(this.ruleForm.leixing)
    this.getYue()
  },
  mounted() {
    const that = this
    var uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: 'selectfiles',
      flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
      silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',
      filters: {
        mime_types: [
          { title: 'Image files', extensions: 'jpg' },
          { title: 'Png files', extensions: 'png' },
          { title: 'Rar files', extensions: 'rar' },
          { title: 'Zip files', extensions: 'zip' },
          { title: 'Gif files', extensions: 'gif' }
        ]
      },
      init: {
        PostInit: function() {
          document.getElementById('ossfile').innerHTML = ''
        },
        FilesAdded: function(up, files) {
          if ($('#ossfile').children().length + 1 > 1) {
            that.$confirm(
              '最多上传一张凭证，如要上传多张图片，请打包成压缩包上传！',
              'error'
            )
            return
          }
          set_upload_param(uploader, '', false)
          plupload.each(files, function(file) {
            document.getElementById('ossfile').innerHTML +=
              '<div id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
              '</div>'
          })
        },

        BeforeUpload: function(up, file) {
          check_object_radio()
          get_dirname()
          set_upload_param(up, file.name, true)
        },
        // 上传进度显示
        UploadProgress: function(up, file) {
          var d = document.getElementById(file.id)
          d.getElementsByTagName('b')[0].innerHTML =
            '<span>' + file.percent + '%</span>'
          var prog = d.getElementsByTagName('div')[0]
          var progBar = prog.getElementsByTagName('div')[0]
          progBar.style.width = 3 * file.percent + 'px'
          progBar.setAttribute('aria-valuenow', file.percent)
        },
        // 上传完成后
        FileUploaded: function(up, file, info) {
          if (info.status == 200) {
            f = true
            imgSrc =
              'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
              get_uploaded_object_name(file.name)
          } else {
            f = false
            document
              .getElementById(file.id)
              .getElementsByTagName('b')[0].innerHTML = info.response
          }
        },

        Error: function(up, err) {
          document
            .getElementById('console')
            .appendChild(document.createTextNode('\nError xml:' + err.response))
        }
      }
    })

    uploader.init()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
        return [3, 1]
      }
    },
    // 默认选中全部
    tt(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      }
    },
    // 获取选中的
    handleSelectionChange(val) {
      this.Data = val
      if (this.tableData.data.length == val.length) {
        this.total_price = this.tableData.data[0].total_price
        this.ruleForm.jine = this.tableData.data[0].total_price
      } else {
        let tPrice = 0
        for (let key in this.Data) {
          tPrice += this.Data[key].goods_price
        }
        this.total_price = tPrice
        this.ruleForm.jine = tPrice
      }
    },
    // 验证输入的金额
    verifynum(event) {
      $('.sy-msg').hide()
      let money = $(event.target).val()
      if (money < 0) {
        $(event.target).css('border-color', 'red')
        this.$confirm('退款金额不能小于0', '提示')
        return (this.fflag = false)
      } else if (money > this.total_price) {
        $(event.target).val(this.total_price)
        $(event.target).css('border-color', 'green')
        return (this.fflag = true)
      }
      $(event.target).css('border-color', 'green')
      return (this.fflag = true)
    },
    change() {
      if (this.ruleForm.leixing == 'backmoney') {
        this.ruleForm.jine = this.total_price
      }
      this.ruleForm.liyou = ''
      this.queryBackLiyou(this.ruleForm.leixing)
    },
    // 售后理由列表
    async queryBackLiyou(leixing) {
      let param = new URLSearchParams()
      param.append('backtype', leixing)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/backorder/statuslst',
        data: param
      })
      this.liyouList = res.data
    },
    // 售后订单列表
    async queryOrderDeatil(orderId) {
      let param = new URLSearchParams()
      if (this.id.indexOf('.') == -1) {
        param.append('id', this.id)
      } else {
        this.id = this.id.substring(0, this.id.length - 1)
        param.append('order_no', this.id)
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/backorder/orderxq',
        data: param
      })
      if (res.code == 1) {
        this.tableData.data = res.data
        this.$nextTick(_ => {
          this.tt(res.data)
        })
        this.total_price = res.data[0].total_price
        this.ruleForm.jine = res.data[0].total_price
      }
    },
    // 验证
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.fflag) {
            if (f == true) {
              if (this.disabled) {
                this.ruleForm.phone = ''
                this.ruleForm.expressno = ''
              }
              let param = new URLSearchParams()
              param.append('token', window.localStorage.getItem('token'))
              param.append('query', this.ruleForm.shuoming)

              if (this.Data.length >= 1) {
                let idArr = []
                for (let key in this.Data) {
                  idArr.push(this.Data[key].id)
                }
                param.append('order_id', idArr.join(','))
              } else {
                this.$confirm('请选择要申请售后的商品', '提示')
                return
              }
              param.append('product_id', this.tableData.data[0].product_id)
              param.append('type', 1)
              if (this.d) param.append('money', this.total_price)
              else param.append('money', this.ruleForm.jine)
              param.append('phone', this.ruleForm.phone)
              param.append('expressno', this.ruleForm.expressno)
              param.append('querytype', this.ruleForm.leixing)
              param.append('backcate', this.ruleForm.liyou)
              param.append('backimg', imgSrc)
              param.append('total_price', this.total_price)

              const { data: res } = await this.$http({
                method: 'post',
                url: 'api/backorder/addorder',
                data: param
              })
              if (res.code == 1) {
                this.$message.success('申请成功')
                this.$router.push('/backorder')
              } else {
                this.$confirm('申请失败，' + res.msg + '', '提示')
              }
            } else {
              this.$confirm('请上传凭证', '提示')
            }
          } else {
            this.$confirm('请输入合法的退款金额', '提示')
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.sy-msg,
.success_msg,
.error_msg {
  color: #666;
  font-size: 12px;
}
.success_msg {
  color: green;
}
.error_msg {
  color: red;
}
.box-card {
  .block {
    .sy-tit {
      padding: 15px;
      background-color: #efefef;
      p {
        color: #e83030;
        font-size: 20px;
        margin-bottom: 10px;
      }
      span {
        font-size: 16px;
        color: #e83030;
      }
    }
  }
  .main {
    margin-top: 20px;
    .sy-tit {
      font-size: 16px;
      color: #666;
      margin-bottom: 15px;
    }
    .productInfo {
      position: relative;
      margin-top: 30px;
      width: 400px;
    }
  }
  .f {
    .contaniner {
      position: relative;
      #selectfiles {
        margin-left: 0;
      }
      .uploadmsg {
        position: absolute;
        bottom: 0;
        right: 0px;
        font-size: 12px;
        color: #666;
      }
    }
  }
}
.upload-item {
  position: relative;
  .xing {
    position: absolute;
    top: 3px;
    left: -78px;
    color: #f56c6c;
  }
}
</style>
